<div class="ui-g fondo">
    <div class="ui-g-12 ui-sm-12">
        <section class="beneficios">
            <div class="contenedor-beneficios">
                <div class="descripcion">
                    <div class="form">
                        <iframe class="form-inside" width="100%" height="auto" src="https://providers.mediprocesos.com/#home">
                    </iframe>
                    </div>       
                </div>
            </div>
        </section>
    </div>
</div>



